import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loggedIn: false,
    cache: {},
  },
  mutations: {
    setLogin(state, loggedIn) {
      state.loggedIn = loggedIn
    },
    addTo(state, payload) {
      //state.cache.push(payload)
      state.cache[payload.day] = payload.data
    },
  },
  actions: {},
  modules: {},
})
